import { RHFRadioGroup, Section } from "@arp/react-ndbx";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { AURA_QUESTION } from "../../config/const/enums";
import { isDropDownNumericQuestion } from "../../schema/auraQuestionsSchema";
import { formatDateMonthyear } from "../../utilities/mappingHelper";
import { getReviewQuestionAnsweredValue } from "../../utilities/reviewAuraHealthUtils";
import { ReviewAuraEdit } from "./ReviewAuraEdit";

function ReviewAuraQuestion({ mappedContent, defaultValue, nextAuraQuestion }) {
  const StyledAnswer = styled((props) => (
    <Typography sx={{ marginBottom: 4 }} variant="p2" {...props} />
  ))(({}) => ({}));

  const SingleChoiceAnswer = ({ questionAnswer }) => {
    return <StyledAnswer>{questionAnswer}</StyledAnswer>;
  };

  const UnitizedAnswer = ({ questionAnswer }) => {
    return (
      <StyledAnswer>
        {isDropDownNumericQuestion(nextAuraQuestion) ? (
          <>
            {questionAnswer.unitizedValue} {questionAnswer.unitizedOption}
          </>
        ) : (
          <>
            {questionAnswer} {mappedContent.labelText}
          </>
        )}
      </StyledAnswer>
    );
  };

  const DateChoiceAnswer = ({ questionAnswer }) => {
    return <StyledAnswer>{formatDateMonthyear(questionAnswer)}</StyledAnswer>;
  };

  const BloodPressureAnswer = ({ questionAnswer }) => {
    return (
      <>
        <StyledAnswer>Systolic: {questionAnswer.systolicReading}</StyledAnswer>
        <br />
        <StyledAnswer>
          Diastolic: {questionAnswer.diastolicReading}
        </StyledAnswer>
      </>
    );
  };

  const getQuestionAnswerFormat = () => {
    const questionAnswer = getReviewQuestionAnsweredValue(nextAuraQuestion);
    switch (nextAuraQuestion?.type) {
      case "SINGLE_CHOICE":
      case "TEXT":
      case "NUMERIC":
        return <SingleChoiceAnswer questionAnswer={questionAnswer} />;
      case "UNITIZED":
        return <UnitizedAnswer questionAnswer={questionAnswer} />;
      case "SEARCH":
        return <SingleChoiceAnswer questionAnswer={questionAnswer.label} />;
      case "BLOOD_PRESSURE":
        return <BloodPressureAnswer questionAnswer={questionAnswer} />;
      case "DATE":
        return <DateChoiceAnswer questionAnswer={questionAnswer} />;
      default:
        return "";
    }
  };

  const editQuestion = (questionID) => {
    sessionStorage.setItem("editquestionid", questionID);
    onBackButton();
  };

  return (
    <Section sx={{ textAlign: "left" }}>
      {mappedContent.context && (
        <Section mb={3} sx={{ textAlign: "left" }}>
          <Typography
            mb={4}
            sx={{
              width: "fit-content !important",
            }}
            variant="label-large-bold"
          >
            {mappedContent.context}
          </Typography>
        </Section>
      )}
      {mappedContent.statement && (
        <Typography
          sx={{
            marginBottom: 5 / 2,
            display: "flex",
          }}
          variant="label-large-bold"
        >
          {mappedContent.statement}
        </Typography>
      )}
      {mappedContent.hasYesAndNoOptions === false ? (
        <>
          <RHFRadioGroup
            name={AURA_QUESTION.AURA_QUESTION_NAME}
            value={defaultValue}
            label={mappedContent.richText}
            items={mappedContent.answerOptionList}
            radioPosition="flex-start"
            disableAllOptions={true}
          />
          <ReviewAuraEdit nextAuraQuestion={nextAuraQuestion} />
        </>
      ) : (
        <>
          <Section mb={2} sx={{ textAlign: "left" }}>
            <Typography
              sx={{
                marginBottom: 4,
              }}
              variant="label-large-bold"
              dangerouslySetInnerHTML={{ __html: mappedContent.richText }}
            ></Typography>
          </Section>
          <Section
            mt={0}
            mb={2}
            sx={{ textAlign: "left" }}
            display="flex"
            justifyContent="space-around"
          >
            <Section sx={{ textAlign: "left" }}>
              {getQuestionAnswerFormat()}
            </Section>
            <ReviewAuraEdit nextAuraQuestion={nextAuraQuestion} />
          </Section>
        </>
      )}
    </Section>
  );
}

export default ReviewAuraQuestion;
